import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

// Import all store modules
import { useSuppliersStore } from './suppliers';
import { useCategoriesStore } from './categories';
import { useSettingsStore } from './settings';
import { useUsersStore } from './users';
import { useLayoutStore } from './layout';
import { useAuthStore } from './auth';
import { useUploadStore } from './upload';
import { usePendingSuppliersStore } from './pending-suppliers';
import { useRatingsStore } from './ratings';

// Create the Pinia instance
const pinia = createPinia();

// Use the persistedstate plugin
pinia.use(piniaPluginPersistedstate);

// Export the Pinia instance as the default export
export default pinia;

// Export all stores for easy access
export {
  useSuppliersStore,
  useCategoriesStore,
  useSettingsStore,
  useUsersStore,
  useLayoutStore,
  useAuthStore,
  useUploadStore,
  usePendingSuppliersStore,
  useRatingsStore,
};

export const useStore = () => ({
  auth: useAuthStore(),
  layout: useLayoutStore(),
  suppliers: useSuppliersStore(),
  categories: useCategoriesStore(),
  pendingSuppliers: usePendingSuppliersStore(),
  upload: useUploadStore(),
  users: useUsersStore(),
  ratings: useRatingsStore(),
});
